import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export default {
  getReleases(privateRelease, route) {
    var endpoint = '/releases'
    if (privateRelease, route.path.split("/").length > 1) {
      var privateReleaseName = route.path.split("/")[1]
      endpoint = '/releases/' + privateReleaseName
    }
    
    return apiClient.get(endpoint)
  }
}
